export const validatePhone = (val) => {
    const regex = /^[ 0-9\(\)\+\-]*$/;
    if (val.match(regex)) {
        return true;
    } 
    return false;
}